import { LoadingUtil } from 'lib-vue-v2/util';
import { useMessageBox } from "lib-vue-v2/composables";
import { Resource as CommonResource } from "@/models/Message/Resource/CommonResource";
import { BaseResponseDto } from "./BaseResponseDto";
import { useUserSettingStore } from '@/models/Store/UserSettingStore';
import { ScvLicenseManager } from '@/models/ScvLicenseManager';
import { DivisionDBData } from "@/models/DivisionData";

// C#からくるレスポンス
interface DivisionInfoDto {
    divisionId: number;
    divisionName: string;
    divisionNamePath: string;
    divisionUINamePath: string;
    parentId: number;
    displayOrder: number;
}

interface GetDivisionInfoResponseDto extends BaseResponseDto {
    divisionId: number;
    rankLevel: number;
    viewableDivisionIds: number[];
    divisions: DivisionInfoDto[];
}

// メッセージ用
const { showMessageBox } = useMessageBox();

export default function useGetDivisionDataPackage() {
    /**
     * IPC経由で部署情報を取得し、C#用DTOからフロント用の DivisionDBData クラスへ型変換して返します。
     * @returns [処理の成否, 変換済みの部署リスト]
     */
    const executeAsync = async (): Promise<[boolean, DivisionDBData[]]> => {
        try {
            const userSettingStore = useUserSettingStore();
            LoadingUtil.Start();
            const jsonResponse = await window.chrome?.webview?.hostObjects.class.DivisionInfo();
            if (jsonResponse === undefined) {
                showErrorMessage();
                return [false, []];
            }

            const response = JSON.parse(jsonResponse) as GetDivisionInfoResponseDto;

            // APIエラー時のハンドリング
            if (!response.isSuccess) {
                showErrorMessage();
                return [false, []];
            }

            // ストア（Pinia）への設定保存
            userSettingStore.setUserSetting(
                "",
                response.divisionId,
                "",
                response.viewableDivisionIds,
                (response.rankLevel === 1),
                false,
                "",
                new ScvLicenseManager()
            );

            const mappedDivisions = (response.divisions || []).map(dto => {
                const item = new DivisionDBData();
                item.divisionID = dto.divisionId;
                item.divisionName = dto.divisionName;
                item.divisionNamePath = dto.divisionNamePath;
                item.divisionUINamePath = dto.divisionUINamePath;
                item.parentID = dto.parentId;
                item.displayOrder = dto.displayOrder;
                return item;
            });
            return [true, mappedDivisions];
        }
        catch (error) {
            // 想定外のエラー
            showErrorMessage();
            return [false, []];
        }
        finally {
            LoadingUtil.Stop();
        }
    }

    // エラーメッセージ表示
    const showErrorMessage = (): void => {
        showMessageBox(
            CommonResource.CommonResource.getInstance().getMsgInfo(
                CommonResource.MsgID.GetFailedErrorForMessage
            )
        );
    }

    // 外部公開
    return {
        executeAsync
    }
}
